import { StateCreator } from 'zustand';
import { MempoolActions, GalaxyStore } from '../types';

export interface MempoolSlice extends MempoolActions {}

function calculateCongestionLevel(size: number, count: number): 'low' | 'medium' | 'high' {
  // Based on mempool size in MB and transaction count
  if (size > 300 || count > 100000) return 'high';
  if (size > 100 || count > 50000) return 'medium';
  return 'low';
}

export const createMempoolSlice: StateCreator<
  GalaxyStore,
  [],
  [],
  MempoolSlice
> = (set) => ({
  // Actions only - state is defined in main store
  updateMempool: (stats) => set((state) => {
    const congestionLevel = calculateCongestionLevel(stats.size, stats.count);

    return {
      ...state,
      mempool: {
        ...state.mempool,
        size: stats.size,
        count: stats.count,
        feeHistogram: stats.feeHistogram || state.mempool.feeHistogram,
        congestionLevel: congestionLevel,
      },
    };
  }),
});